// import axios from 'axios';
import React, { useState } from 'react';
import './InputData.styl';

function InputLyrMB(props) {
  return (
    <div className="data-customization-external-geojson-form">

      <div className="data-customization-panel__input__container2">
        <input
          type="text"
          value={props.LyrMB}
          onChange={e => props.setLyrMB(e.target.value)}
          className="data-customization-panel__input"
          placeholder={props.placeholder}
        />
      </div>
    
    </div>
  )
}
export default InputLyrMB